import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response";

export const useCreateStanding = () => {
  const queryClient = useQueryClient();
  const request = useApi();
  const { sport, organizationId, seasonId } = useParams();

  return useMutation<DefaultOperationSuccessResponse, Error, unknown>({
    // will be typed after refactoring of create form
    mutationFn: async (body: unknown) => {
      return await request(`${sport}/o/${organizationId}/seasons/${seasonId}/standings`, { method: "POST", body });
    },
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (response?.data?.[0]) {
        await queryClient.invalidateQueries({
          queryKey: ["standings", sport, organizationId, seasonId],
        });
      }
    },
  });
};
